import { EVENT_TYPE } from '../../constants/eventTypes.js';
import { INTERIM_EVENT_TYPE } from '../../constants/interimEventTypes.js';
import GenericEventBody from './GenericEventBody.jsx';
import { ContinuationBody } from '../EventTypes/Continuation/index.js';
import { HandoffBody } from '../EventTypes/Handoff/index.js';
import { QuestionBody } from '../EventTypes/Question/index.js';
import { TrainMeBody } from '../EventTypes/TrainMe/index.js';
import { GovPromotionBody } from '../EventTypes/GovPromotion/index.js';
import { GovReviewBody } from '../EventTypes/GovReview/index.js';
import { BreakGlassBody } from '../EventTypes/BreakGlass/index.js';
import { ChangeRequestBody } from '../EventTypes/ChangeRequest/index.js';
import { ClaimSuggestionBody } from '../EventTypes/ClaimSuggestion/index.js';
import { ProposalBody } from '../EventTypes/Proposal/index.js';
import { TaskBody } from '../EventTypes/Task/index.js';

/**
 * Maps an event type to its detail-body component. Per-event-type stories
 * (CT-4859..CT-4865) register their richer bodies here; unregistered types fall
 * back to the generic SITUATION/pipeline/destination body. The per-type decision
 * bar is resolved separately (see EventDecision/decisionRegistry).
 *
 * The INTERIM_EVENT_TYPE entries are the backend-connection sources (CT-5091+):
 * they paint the real GS detail (change-request/preview, …) instead of the
 * generic body while CT-4867's unified HTL events endpoint is pending.
 */
export const EVENT_BODY_REGISTRY = {
  [EVENT_TYPE.HTL_CONTINUATION]: ContinuationBody,
  [EVENT_TYPE.CLIENT_CONTINUATION]: ContinuationBody,
  [EVENT_TYPE.HTL_HANDOFF]: HandoffBody,
  [EVENT_TYPE.CLIENT_HANDOFF]: HandoffBody,
  [EVENT_TYPE.QUESTION]: QuestionBody,
  [EVENT_TYPE.TRAIN_ME]: TrainMeBody,
  [EVENT_TYPE.GOV_PROMOTION]: GovPromotionBody,
  [EVENT_TYPE.GOV_REVIEW]: GovReviewBody,
  [EVENT_TYPE.GOV_BREAK_GLASS]: BreakGlassBody,
  [INTERIM_EVENT_TYPE.CHANGE_REQUEST]: ChangeRequestBody,
  [INTERIM_EVENT_TYPE.CLAIM_SUGGESTION]: ClaimSuggestionBody,
  [INTERIM_EVENT_TYPE.PROPOSAL]: ProposalBody,
  [INTERIM_EVENT_TYPE.TASK]: TaskBody,
};

export function resolveEventBody(type) {
  return EVENT_BODY_REGISTRY[type] ?? GenericEventBody;
}
